import React from "react"
import { Tooltip } from "react-tooltip"
import { ReactComponent as CheckIcon } from "images/icons/check-thick.svg"
import { ReactComponent as ClockIcon } from "images/icons/clock.svg"
import { SessionGroup } from "./types"
import { StatusContainer, Section as OrderSection } from "./CustomerOrderTable.styled"

type Props = {
  sessionGroup: SessionGroup
}

const SessionStatus = ({ sessionGroup }: Props) => {
  const confirmedCount = sessionGroup.checkouts.filter(c => c.isConfirmed).length
  const totalCount = sessionGroup.checkouts.length
  const hasConfirmed = confirmedCount > 0
  const allConfirmed = confirmedCount === totalCount
  const tooltipId = `session-${sessionGroup.sessionId}`

  const getStatusText = () => {
    if (allConfirmed) return `Checkout confirmed`
    if (hasConfirmed) return `${confirmedCount} of ${totalCount} checkouts confirmed`
    return `No confirmed checkout, (${totalCount} pending)`
  }

  return (
    <OrderSection>
      <Tooltip id={tooltipId}>
        <div>{getStatusText()}</div>
      </Tooltip>
      <StatusContainer $blocked={!hasConfirmed} data-tooltip-id={tooltipId}>
        {hasConfirmed ? <CheckIcon /> : <ClockIcon />}
      </StatusContainer>
    </OrderSection>
  )
}

export default SessionStatus